import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {Observable, of, tap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {BaseSelect} from "../../core/classes/base.component";
import {ProjectInfo} from "../../core/interfaces/project.interface";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CustOrderService} from "../../core/services/routes-services/custOrder.service";

@Component({
    selector: 'app-cust-order-select',
    // exportAs: 'ngModel', disabled until finding out how to replace #project="ngModel" attribute of <app-project-select> to render validation errors via <span *ngIf="project.invalid && (project.dirty || project.touched)">
    templateUrl: './cust-order-select.component.html',
    styleUrls: ['./cust-order-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustOrderSelectComponent),
            multi: true
        }
    ]
})
export class CustOrderSelectComponent extends BaseSelect<ProjectInfo> implements ControlValueAccessor {

    @Output() selectionChanged = new EventEmitter<any>();

    private _project: number

    formControl: FormControl<any>
    onChange: (value: any) => void = () => {};
    onTouched: () => void = () => {};

    constructor(
        private _service: CustOrderService,
    ) {
        super(true)
        this.formControl = new FormControl()
    }

    trackByFn(item: ProjectInfo) {
        return item.id;
    }

    override executeRequest(term): Observable<any> {
        const req = this.request()
        return this._service.filter(term, req).pipe(
            map(res => {
                const { data } = res;
                return data as ProjectInfo[]
            }),
            catchError(() => of([])), // empty list on error
            tap(() => (this.loading = false)),
        )
    }

    override fill(filters: any) {
        super.fillBasicFilters(filters, 'CUST_ORDER')
        filters['CUST_ORDER'] = {
            company:  this._companyId ? [this._companyId] : null,
            project:  this._project,
        }
    }

    // @Input() @Output()
    // value: any
    onSelectionChange(ev) {
        this.selectionChanged.emit(ev)
    }

    onInput(value: any): void {
        this.value = value;
        this.selectionChanged.emit(value)
        this.onChange(value);
    }

    get value(): any {
        return this.selectedEntries;
    }

    set value(value: any) {
        this.selectedEntries = value;
        this.formControl.setValue(value, { emitEvent: false });
        // if(!value)
        //     this.formControl.reset()
    }

    @Input()
    set project(value: number) {
        this._project = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    writeValue(value: any): void {
        this.selectedEntries = value;
        if(this.select)
            this.select.writeValue(value)
    }

    setDisabledState(isDisabled: boolean): void {
        if(this.select)
            this.select.setDisabledState(isDisabled) // Update the internal state
    }

    updateEntries(value?: any) {
        if(value) {
            this.entries = [value];
            this.selectedEntries = value;
            this.select.itemsList.setItems(this.entries)
            this.select.select(this.select.itemsList.items[0])
        }
        else {
            this.entries = [];
            this.selectedEntries = null;
            this.select.itemsList.setItems(this.entries)
        }
    }

}
